import { EVENTS } from "@bash/shared";
import type { Socket } from "socket.io-client";
import { useTaskStore } from "../taskStore";
import type { ClientPayloadOf } from "../socketService";

export function registerSuggestionHandlers(socket: Socket): () => void {
  const taskStore = useTaskStore;

  // UNDECLARED by the wire contract (s2-07b finding): sessionId — read here, absent from PromptSuggestionPayload.
  const handlePromptSuggestion = (data: ClientPayloadOf<typeof EVENTS.PROMPT_SUGGESTION> & { sessionId?: string }) => {
    const taskId = data.taskId || data.sessionId;
    if (!taskId || !data.suggestion) return;

    // Substrate-v2: the legacy "if agent text-renders 'Connect X', synthesize
    // a faux pendingInteraction without interactionId" path was deleted. It
    // race-overwrote the substrate's properly-formed pendingInteraction and
    // produced /api/interactions//resolve 404s when the user clicked Connect
    // post-expiry. The substrate is now the only mechanism that sets
    // pendingInteraction with type='auth' — set via interactionHandlers on
    // the INTERACTION_REQUIRED socket event.
    //
    // The non-auth path remains: a plain text suggestion is still rendered
    // as a "Try it" chip above the input.
    taskStore.getState()._mutateTasks((tasks) => {
      const task = tasks.get(taskId);
      if (!task) return;
      task.promptSuggestion = data.suggestion;
    });
  };

  socket.on(EVENTS.PROMPT_SUGGESTION, handlePromptSuggestion);

  return () => {
    socket.off(EVENTS.PROMPT_SUGGESTION, handlePromptSuggestion);
  };
}
